module.exports = __webpack_public_path__ + "static/img/larouPic.ea0bcd78.png";